<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer014">
<p class="Page-heading" id="_idParaDest-1"><a id="_idTextAnchor000"></a>About the Author</p>
<p class="Prelims">Christina’s love for storytelling and illustrations stem from the classic fairy tales she grew up on.</p>
<p class="Prelims">Her whimsical outlook keeps her inner-child alive in creating funny stories adults and children can enjoy. Christina currently resides in Chandler, Indiana with her husband and a little monster.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781645360742_EPUB.vue?ce8d2480